module.exports = __webpack_public_path__ + "static/img/8.ea01e00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/zh/8.png
// module id = R4xH
// module chunks = 0